import { render, staticRenderFns } from "./searchpage.vue?vue&type=template&id=655bcada&"
import script from "./searchpage.vue?vue&type=script&lang=ts&"
export * from "./searchpage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655bcada')) {
      api.createRecord('655bcada', component.options)
    } else {
      api.reload('655bcada', component.options)
    }
    module.hot.accept("./searchpage.vue?vue&type=template&id=655bcada&", function () {
      api.rerender('655bcada', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/search/searchpage.vue"
export default component.exports